import { render, staticRenderFns } from "./AddTokenVariablePopup.vue?vue&type=template&id=58b1a674&scoped=true"
import script from "./AddTokenVariablePopup.vue?vue&type=script&lang=js"
export * from "./AddTokenVariablePopup.vue?vue&type=script&lang=js"
import style0 from "./AddTokenVariablePopup.vue?vue&type=style&index=0&id=58b1a674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1a674",
  null
  
)

export default component.exports